import { CustomerInfoSchema } from "./CustomerSchema";

export function CustomerItem({item, isSelected, listMode, onClick, onCheckChange }: { item: CustomerInfoSchema, isSelected:boolean,listMode:boolean,  onClick: (id: string) => void, onCheckChange: (id: string, checked: boolean) => void}) {



  
  return listMode?(
    <div  key={item.customerId} className={item.isDeleted ?  " relative hidden" : "relative"}>
      <input type="checkbox" className="absolute top-[8px] right-0 scale-150 accent-sky-600 dark:accent-orange-400" id={`item-${item.customerId}`} 
      checked={isSelected}
      
      onChange={(e) => { onCheckChange(item.customerId as string, e.target.checked); e.stopPropagation();}}      />
    <div className="w-[220px]  pt-3 pb-3 px-2 border rounded-md border-red-700 cursor-pointer" onClick={() => onClick(item.customerId as string)}>
    <div className="logo h-[90px] flex justify-center">
      <img src={`data:image/png;base64,${item.logo}`} className="h-[75px]" />
      </div>
      <div className="info h-[75px]">
        <h3 className="description font-bold">{item.name}</h3>
        <p className="name h-[50px] text-wrap truncate">{item.address}</p>
      </div>

     
    </div>
   
    </div>
  ):(
    <tr key={item.customerId} className="border-t hover:bg-gray-100 cursor-pointer dark:bg-zinc-700 dark:hover:bg-zinc-600" onClick={() => onClick(item.customerId as string)}>
      <td className="px-4 py-2 center-text">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onCheckChange(item.customerId as string, e.target.checked)}
          onClick={(e) => e.stopPropagation()}
          className="accent-sky-600 dark:accent-orange-400 w-4 h-4"
        />
      </td>
      <td className="py-2"><img src={item.logo?`data:image/png;base64,${item.logo}`:undefined} className="h-[30px]"/></td>
      <td className="px-4 py-2">{item.name}

        {item.error ? (
          <p className="name text-wrap truncate text-red-600 font-bold">{item.error}</p>
        ):null}
      </td>
      <td className="px-4 py-2 whitespace-pre-line">{item.address}</td>
      <td className="px-4 py-2">{item.phone}</td>
      <td className="px-4 py-2">{item.email}</td>
      <td className="px-4 py-2">
         <input
          type="checkbox"
          checked={item.isActive}
          readOnly
          className="accent-sky-600 dark:accent-orange-400 w-4 h-4"
        />
      </td>
     
      
    </tr>
    
  )
  
}